import React, { useEffect } from "react";
import { useQuestionContext } from "lib/providers/questionProvider";
import { FormState } from "./Skips.validation";

interface LoadQueryParamsProps {
  queryParams: FormState;
}

export const LoadQueryParams = ({
  queryParams,
}: LoadQueryParamsProps): null => {
  const context = useQuestionContext<FormState>();

  useEffect(() => {
    const { type, refAndPostcode, wasteTypeAndPostcode } = queryParams;

    if (typeof type === "undefined") {
      return;
    }

    context.close("type");
    context.open(
      type === "SKIPHIRE" ? "wasteTypeAndPostcode" : "refAndPostcode",
    );
    if (refAndPostcode?.postcode && refAndPostcode?.ref) {
      context.close("refAndPostcode").open("exchange");
    }
    if (wasteTypeAndPostcode?.postcode && wasteTypeAndPostcode.wasteType) {
      context.close("wasteTypeAndPostcode").open("product");
    }
  }, []);

  return null;
};
